import React, { useCallback } from 'react'
import { CustomAnchor, ListItem, NoDataView } from '..'
import { getParsedDate } from '../../utils'
import PageLoader from '../page-loader'

const PastChats = ({ onClickChat, loading, data: pastChats, onClickDelete }) => {

    const onClickPastChat = useCallback((pastChatData) => {
        if (onClickChat) {
            onClickChat(pastChatData)
        }
    }, [onClickChat])

    const onClickDeleteChat = useCallback((chatId) => {
            if (onClickDelete) {
                onClickDelete(chatId)
            }
    }, [onClickDelete])

    return (
        <>
            <div className='bimmatch-past-chats'>
                <div className='past-chat-header'>
                    <img src='/images/icon/history.svg' alt='past-chat-icon' className='past-chat-icon' />
                    <p className='past-chat-title'>Past chats</p>
                </div>
                {loading ? (
                    <PageLoader />
                ) : (
                    <div className='chats'>
                        {!pastChats?.length && (
                            <NoDataView noDataText='No past chats found' size='medium' />
                        )}
                        {pastChats.map((pastChatData, index) => (
                                <ListItem
                                    key={pastChatData?.id || pastChatData?.chatId || `pastChatData-${index}`}
                                    title={<CustomAnchor onClick={() => onClickPastChat(pastChatData)}>{pastChatData?.title || pastChatData?.chatId}</CustomAnchor>}
                                    updatedAt={getParsedDate(pastChatData.updatedAt || pastChatData.createdAt)}
                                    optionMenuItems={[{ id: "delete", src: "/images/icon/trash.svg", label: "Delete", onClick: () => onClickDeleteChat(pastChatData) }]}
                                    popoverClassName={'past-chat-popover'}
                                />
                        ))}
                    </div>
                )}
            </div>
        </>
    )
}

export default PastChats